import { ApiTypes } from "@/types/server/api.types";
import { LogType } from "@/types/server/enums.types";

export const createWindowSwitchLog = async (
	interviewId: string,
	logType: LogType
) => {
	const response = await fetch(
		`${import.meta.env.VITE_SERVER_API_PREFIX}/logs/${interviewId}`,
		{
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				logType,
			}),
		}
	);

	const responseData = (await response.json()) as ApiTypes.TCreateLogResponse

	return responseData;
};